import { type ReactNode } from 'react'
import cx from 'classnames'
import styles from './PageNavigation.module.css'
import { Icon, type IconName } from '@/components/Icon'
import { type PressEventHandler } from '@/infra/prop-types'
import { RawLink } from '@/components/Link'

export interface PageNavigationProps {
  children?: ReactNode
  testId?: string
}

/**
 * The PageNavigation
 */
export function PageNavigation({ children, testId }: PageNavigationProps) {
  return (
    <nav data-test={testId} className={cx(styles.root)}>
      <ul className={styles.list}>{children}</ul>
    </nav>
  )
}

interface PageNavigationItemProps {
  icon: IconName
  label: string
  to?: string
  href?: string
  onPress?: PressEventHandler
  testId?: string
}

/**
 * Page Navigation Item
 */
export function PageNavigationItem({
  icon,
  label,
  testId,
  ...rest
}: PageNavigationItemProps) {
  return (
    <li className={styles.item}>
      <RawLink
        {...rest}
        data-test={testId}
        className={({ isPressed, isHovered, isFocusVisible, isActive }) =>
          cx(
            styles.link,
            isPressed && styles.pressed,
            isHovered && styles.hover,
            isFocusVisible && styles.focusVisible,
            isActive && styles.active,
          )
        }
      >
        <span className={styles.icon}>
          <Icon name={icon} />
        </span>
        <span className={styles.text}>{label}</span>
        <span className={styles.chevron}>
          <Icon name="chevron" />
        </span>
      </RawLink>
    </li>
  )
}
